<template>
  <div>
    <v-dialog v-bind:fullscreen="$vuetify.breakpoint.mdAndDown" scrollable
              v-bind:value="value"
              v-on:input="$emit('input', $event)"
              width="600">
      <v-card>
        <dialog-header v-bind:close-label="$t('close')"
                       v-bind:image-src="spot.headerImageId != null ? attachmentUrl(spot.headerImageId) : defaultImageUrl"
                       v-bind:title="spot.title"
                       v-on:close="$emit('input', false)">
          <v-avatar color="accent"
                    size="64"
                    slot="avatar">
            <v-icon dark>mdi-fire</v-icon>
          </v-avatar>
          <template slot="subtitle">
            <v-icon class="mr-1"
                    dark
                    x-small>
              mdi-tag
            </v-icon>
            {{ spot.description }}
          </template>
        </dialog-header>

        <v-tabs class="flex-grow-0"
                color="accent"
                grow
                v-if="!!spot.menuImageId || !!spot.routeImageId"
                v-model="tab">
          <v-tab href="#details">
            <v-icon left
                    small>
              mdi-information-outline
            </v-icon>
            {{ $t('details' )}}
          </v-tab>
          <v-tab href="#deals"
                 v-if="!!spot.menuImageId">
            <v-icon left
                    small>
              mdi-fire
            </v-icon>
            {{ $t('deals') }}
          </v-tab>
          <v-tab href="#menu"
                 v-if="!!spot.routeImageId">
            <v-icon left
                    small>
              mdi-food-fork-drink
            </v-icon>
            {{ $t('menu') }}
          </v-tab>
        </v-tabs>
        <v-divider />

        <v-card-text class="pa-0">
          <v-tabs-items v-model="tab">
            <v-tab-item value="details">
              <!-- DETAILS -->
              <!-- ------- -->
               <v-list class="pt-0"
                      two-line>
                <v-list-item v-if="!!spot.hours">
                  <v-list-item-icon>
                    <v-icon color="accent">mdi-calendar-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ `${spot.hours}` }}</v-list-item-title>
                    <v-list-item-subtitle>{{ $t('hours') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="spot.contact != null && spot.contact.length !== 0">
                  <v-list-item-icon>
                    <v-icon color="accent">mdi-phone-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ spot.contact }}</v-list-item-title>
                    <v-list-item-subtitle>{{ $t('contact') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="spot.specialFacts != null && spot.specialFacts.length !== 0">
                  <v-list-item-icon>
                    <v-icon color="accent">mdi-star-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ spot.specialFacts }}</v-list-item-title>
                    <v-list-item-subtitle>{{ $t('specialFacts') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-img v-if="!!spot.imageId" 
              class="ma-4 rounded-lg"
               v-bind:src="attachmentUrl(spot.imageId)" />
              <div class="d-flex flex-wrap pb-3 px-2"
                   v-if="canShare">
                <quick-action icon="mdi-share-variant-outline"
                              v-bind:label="$t('share')"
                              v-on:click="share" />
              </div>
            </v-tab-item>
            <v-tab-item value="deals">
              
              <!-- DEALS -->
              <!-- ----- -->
              <v-img v-if="!!spot.menuImageId" 
              class="ma-4"
               v-bind:src="attachmentUrl(spot.menuImageId)" />
            </v-tab-item>
            <v-tab-item value="menu">
              <!-- MENU -->
              <!-- ----- -->
               <div>
              
                <v-carousel v-model="carousel" hide-delimiters
                            height="500"
                            :show-arrows="!!spot.routeImageId2 || !!spot.routeImageId3">
                  <v-carousel-item v-if="!!spot.routeImageId">
                    <v-sheet tile>
                        <v-img  v-bind:src="attachmentUrl(spot.routeImageId)" height="500" contain />
                    </v-sheet>
                  </v-carousel-item>
                  <v-carousel-item v-if="!!spot.routeImageId2">
                    <v-sheet tile>
                        <v-img  v-bind:src="attachmentUrl(spot.routeImageId2)" height="500" contain />
                    </v-sheet>
                  </v-carousel-item>
                  <v-carousel-item v-if="!!spot.routeImageId3">
                    <v-sheet tile>
                        <v-img  v-bind:src="attachmentUrl(spot.routeImageId3)" height="500" contain />
                    </v-sheet>
                  </v-carousel-item>
                </v-carousel>
               </div>
               
             
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>

        
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  import moment from 'moment'

  import settings from '../settings'

  import DialogHeader from '@/components/common/DialogHeader'
  import QuickAction from '@/components/common/QuickAction'

  export default {
    components: {
      DialogHeader,
      QuickAction
    },
    computed: {
      canShare() {
        return navigator.share != null
      },
      description() {
        if (this.spot?.description == null) {
          return ''
        }

        return this.spot.description.replace(/\n/g, '<br>')
      },
      ...mapGetters({

        attachmentUrl: 'attachmentUrl'
      })
    },
    created() {
      this.selectedWeek = moment().isoWeek()
    },
    data: () => ({
      defaultImageUrl: `${process.env.BASE_URL}images/food-truck-default-image.jpg`,
      tab: 'details',
      carousel: null
    }),
    methods: {
      async open() {
        this.$emit('input', true)
      },
      mapUrl(timeSlot) {
        let baseUrl = 'http://maps.google.com/maps'

        if (navigator.platform.indexOf('iPad') != -1 ||
          navigator.platform.indexOf('iPhone') != -1 ||
          navigator.platform.indexOf('iPod') != -1 ||
          navigator.platform.indexOf('Mac') != -1) {
          baseUrl = 'maps://maps.google.com/maps'
        }

        return `${baseUrl}?daddr=${timeSlot.latitude},${timeSlot.longitude}&amp;ll=`
      },
      async share() {
        await navigator.share({
          title: this.spot.title,
          text: this.spot.description,
          url: `${settings.baseUrl}/spots/?id=${this.spot.id}`,
        })
      }
    },
    name: 'SpotDialog',
    props: {
      spot: Object,
      selectedDate: String,
      value: Boolean
    },
    watch: {
      spot() {
        // Not every spot has deals or a menu, so always start on the details
        this.tab = 'details'
      }
    }
  }
</script>

<style scoped>
.scrollable-container {
  overflow-y: scroll;
  max-height: 500px;
}
</style>

<i18n>
  {
    "de": {
      "close": "Schließen",
      "details": "Details",
      "deals": "Angebote",
      "menu": "Speisekarte",
      "hours": "Öffnungszeiten",
      "contact": "Kontakt",
      "specialFacts": "Special Facts",
      "share": "Teilen"
    },
    "en": {
      "close": "Close",
      "details": "Details",
      "deals": "Deals",
      "menu": "Menu",
      "hours": "Hours",
      "contact": "Contact",
      "specialFacts": "Special Facts",
      "share": "Share"
    }
  }
</i18n>